var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPrimaryArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ED0334",
  d: "M9.497 4.118c-1.121-.725-2.263-.78-3.218.175s-.883 2.08-.175 3.218L8.3 11.058c.415.679.457 1.149.05 1.795l-2.117 3.45c-.684 1.094-.713 2.218.295 3.226 1.01 1.01 2.133.98 3.227.296l8.49-5.31c.382-.244.663-.424.893-.654.955-.955.844-2.45-.148-3.442a5.5 5.5 0 0 0-.817-.653z"
})));
export default SvgIconPrimaryArrow;